module.exports = __webpack_public_path__ + "static/media/briefTwo.7ad6e5e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/briefTwo.jpg
// module id = 1737
// module chunks = 0 1